module.exports = __webpack_public_path__ + "img/Knudsen_Hesthagen_i_Holt.8ac9a44f.jpg";